import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import { isEmpty } from 'lodash'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { Box, Hidden, Paper, TablePagination } from '@material-ui/core'

import { LoadingFeedback, NoData2 } from 'components'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'

import { ActivitiesTableTabs, ActivitiesTableRow } from './components'

import useKanban from 'hooks/useKanban'

const ActivitiesTable = ({ onEditCard, onDeleteCard }) => {
  const {
    columns,
    listCurrentTab,
    listLoading,
    listPage,
    listPerPage,
    listTasks,
    listTotalCount,
    hasUnlinked,
    hasSourceRemoved,
    handleListChangePage,
    handleListChangeRowsPerPage,
    handleListTabChange,
  } = useKanban()

  const columnMap = useMemo(
    () =>
      columns.reduce((acc, col) => {
        acc[col.id] = col
        return acc
      }, {}),
    [columns],
  )

  return (
    <Paper>
      <LoadingFeedback open={listLoading} />
      <ActivitiesTableTabs
        columns={columns}
        currentTab={listCurrentTab}
        onTabChange={handleListTabChange}
        hasUnlinked={hasUnlinked}
        hasSourceRemoved={hasSourceRemoved}
      />
      {!isEmpty(listTasks) ? (
        <>
          <Box width="100%">
            <PerfectScrollbar
              options={{ wheelPropagation: false, useBothWheelAxes: true }}
            >
              <Table size="small" noWrap>
                <TableHead>
                  <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell>Nome</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Prioridade</TableCell>
                    <TableCell>Responsável</TableCell>
                    <TableCell>Prazo</TableCell>
                    <TableCell>Data de Criação</TableCell>
                    <TableCell align="right">Ações</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {listTasks.map((task) => (
                    <ActivitiesTableRow
                      key={task.id}
                      task={task}
                      columnMap={columnMap}
                      onEditCard={onEditCard}
                      onDeleteCard={onDeleteCard}
                    />
                  ))}
                </TableBody>
              </Table>
            </PerfectScrollbar>
          </Box>
          <TablePagination
            component="div"
            count={listTotalCount}
            onPageChange={handleListChangePage}
            onRowsPerPageChange={handleListChangeRowsPerPage}
            page={listPage - 1}
            rowsPerPage={listPerPage}
            rowsPerPageOptions={[5, 10, 25, 100]}
            labelRowsPerPage={<Hidden smDown>Por página</Hidden>}
            nextIconButtonProps={{ size: 'small' }}
            backIconButtonProps={{ size: 'small' }}
          />
        </>
      ) : (
        <NoData2 title="Nenhuma atividade encontrada." />
      )}
    </Paper>
  )
}

ActivitiesTable.propTypes = {
  onEditCard: PropTypes.func.isRequired,
  onDeleteCard: PropTypes.func.isRequired,
}

export default ActivitiesTable
